"use client";
import { useState } from "react";
import Image from "next/image";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import NavLogo from "../../../public/logo.svg";
import NavLogoDark from "../../../public/logoblack.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt, faRocket, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

function NavbarSection() {
  const breakpoints = ["xl"];
  const [openDropdown, setOpenDropdown] = useState<number | null>(null); // Move inside the function

  const handleMouseEnter = (index: number) => {
    setOpenDropdown(index);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  const dropdownData = [
    {
      title: "Managed Cloud",
      items: [
        { title: "Managed Amazon Cloud", link: "/managed-amazon-cloud-hosting" },
        { title: "Managed DigitalOcean Cloud", link: "/managed-digitalocean-hosting" },
        { title: "Managed Prestashop Cloud", link: "/managed-prestashop-cloud-hosting" },
        { title: "Managed MySQL Hosting", link: "/managed-mysql-hosting" },
        { title: "Managed MongoDB Hosting", link: "/managed-mongodb-hosting" },
        { title: "Managed Odoo Hosting", link: "/managed-odoo-hosting" },
        { title: "Managed Magento Cloud", link: "/managed-magento-cloud-hosting" },
        { title: "Managed Wordpress Cloud", link: "/managed-wordpress-cloud-hosting" },
        { title: "Managed WooCommerce Cloud", link: "/managed-woocommerce-cloud-hosting" },
        { title: "Managed PostgreSQL Hosting", link: "/managed-postgresql-hosting" },
        { title: "Managed Oracle Hosting", link: "/managed-oracle-hosting" },
        { title: "Managed Elasticsearch Hosting", link: "/managed-elasticsearch-hosting" },
        { title: "Managed PHP Cloud", link: "/managed-php-cloud-hosting" },
        { title: "Managed Laravel Cloud", link: "/managed-laravel-cloud-hosting" },
        { title: "Managed Kubernetes Hosting", link: "/managed-kubernetes-hosting" },
        { title: "Managed Redis Hosting", link: "/managed-redis-hosting" },
        { title: "Managed MariaDB Hosting", link: "/managed-mariadb-hosting" },
        { title: "Managed Prometheus Hosting", link: "/managed-prometheus-hosting" },
        { title: "Managed Drupal Cloud", link: "/managed-drupal-cloud-hosting" },
        { title: "Managed Joomla Cloud", link: "/managed-joomla-cloud-hosting" },
        { title: "Managed Hyper-V Cloud Hosting", link: "/managed-hyper-v-cloud-hosting" },
        { title: "Managed Kafka Hosting", link: "/managed-kafka-hosting" },
        { title: "Managed OpenCart Hosting", link: "/managed-opencart-hosting" },
      ],
    },
    {
      title: "Servers",
      items: [
        { title: "Dedicated Servers", link: "/dedicated-servers-usa" },
        { title: "Linux Virtual Private Servers", link: "/linux-virtual-private-server-vps-usa" },
        { title: "Special Dedicated Servers", link: "/dedicated-special-deals" },
        { title: "Apple Mac Servers", link: "/apple-mac-mini-m2-usa" },
        { title: "Windows Remote Desktop Servers (RDP)", link: "/windows-remote-desktop-usa" },
        { title: "Windows Virtual Private Servers", link: "/windows-virtual-private-server-vps-usa" },
      ],
    },
    {
      title: "Collaboration",
      items: [
        { title: "Google Workspace", link: "/buy-google-workspace" },
      ],
    },
    {
      title: "Hosting",
      items: [
        { title: "Linux Shared Hosting", link: "/linux-shared-hosting-usa" },
        { title: "Linux SEO Hosting", link: "/linux-seo-hosting" },
        { title: "Linux Reseller Hosting", link: "/linux-reseller-hosting-usa" },
        { title: "Windows Shared Hosting", link: "/windows-shared-hosting-usa" },
        { title: "Windows Reseller Hosting", link: "/windows-reseller-hosting-usa" },
      ],
    }
    ,
    {
      title: "Domains",
      items: [
        { title: "Domain Registrations", link: "/domain-registrations " },
        { title: "International Domains", link: "/international-domains" },
        { title: "Bulk Registration", link: "/bulk-registration" },
        { title: "Bulk Transfer", link: "https://clients.temok.com/cart.php?a=add&domain=transfer" },
        { title: "Domain Transfer", link: "https://clients.temok.com/cart.php?a=add&domain=transfer" },
        { title: "Domain Pricing", link: "/domain-pricing" },
        { title: "Domain Renewals", link: "https://clients.temok.com/index.php?rp=/login" },
      ],
    },
    {
      title: "CyberSecurity",
      items: [{ title: "Acronis Cyber Protect", link: "/acronis-cyber-protect-cloud" }],
    },
    {
      title: "Partners",
      items: [
        { title: "Reseller Partner Program", link: "https://partners.temok.com/" },
        { title: "WhiteLabel Managed Service Providers", link: "https://partners.temok.com/WhitelabelManagedServiceProviders" },
        { title: "Affiliate Program", link: "https://partners.temok.com/AffiliatesProgram" },
      ],
    },
  ];

  return (
    <>
      {breakpoints.map((expand) => (
        <Navbar expand={expand} data-bs-theme="dark" className="py-3 navBg" key={expand}>
          <Container className="eventsNav">
            <Navbar.Brand href="/">
              <Image src={NavLogo} width={150} height={32} alt="Temok" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <Image src={NavLogoDark} width={150} height={32} alt="Temok" />
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="m-auto">
                  {dropdownData.map((dropdown, index: number) => (
                    <NavDropdown
                      key={index}
                      title={
                        <span className="d-flex align-items-center">
                          {dropdown.title}
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            className={`ms-2 transition ${openDropdown === index ? "rotate-180" : ""}`}
                          />
                        </span>
                      }
                      id={`offcanvasNavbarDropdown-expand-${expand}`}
                      onMouseEnter={() => handleMouseEnter(index)}
                      onMouseLeave={handleMouseLeave}
                      show={openDropdown === index} // Open dropdown on hover
                    >
                      <div className="container">
                        <div className="row">
                          {dropdown.items.map((item, i: number) => (
                            <div key={i} className="col-xl-4 col-lg-4 col-md-12 col-12">
                              {item.link.startsWith("http") ? (
                                <NavDropdown.Item as="a" href={item.link} target="_blank" rel="noopener noreferrer">
                                  {item.title}
                                </NavDropdown.Item>
                              ) : (
                                <NavDropdown.Item href={item.link}>{item.title}</NavDropdown.Item>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </NavDropdown>
                  ))}
                </Nav>

                <Nav className="custBoot">
                  <Button variant="outline-secondary" className="fntSize py-0 px-3 rounded-3 mx-1" size="sm">
                    <a href={`${process.env.NEXT_PUBLIC_API_BASE_URL}/login.php`} target="_blank" className="text-decoration-none custBtn">
                      <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                      Login
                    </a>
                  </Button>
                  <Button variant="primary" size="sm" className="fntSize py-0 px-3 rounded-3  mx-1">
                    <a href={`${process.env.NEXT_PUBLIC_API_BASE_URL}/register.php`} target="_blank" className="text-decoration-none text-white custBtn0">
                      <FontAwesomeIcon icon={faRocket} className="me-2" />
                      Get Started Free
                    </a>
                  </Button>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default NavbarSection;
